export const GAME_USER_LOGIN_ACTION_PERSIST = "GAME_USER_LOGIN_PERSIST";
export const GAME_USER_LOGIN_ACTION_CLEAR = "GAME_USER_LOGIN_CLEAR";
